// Simple Debounce Filter - creates a custom debounce function
// Example Use:
//   const debouncedFn = debounce(() => DoStuff())
//   debouncedFn()
module.exports = function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
